// @ts-check

/**
 * @param {import('../').EquinoxProductInventoryProperties} inventoryProperties 
 */
function mapInventoryProperties(inventoryProperties = {}) {
  /** @type {import('../').EquinoxProductInventoryProperties} */
  const model = {};
  model.available = mapAvailable(inventoryProperties.available);
  model.lowStock = mapLowStock(inventoryProperties.lowStock);
  model.binName = mapBinName(inventoryProperties.binName);
  model.backOrdered = mapBackOrdered(inventoryProperties.backOrdered);
  model.expectedBackOrderAvailabilityDate = mapExpectedBackOrderAvailabilityDate(
    inventoryProperties.expectedBackOrderAvailabilityDate
  );
  model.preOrdered = mapPreOrdered(inventoryProperties.preOrdered);
  model.expectedPreOrderAvailabilityDate = mapExpectedPreOrderAvailabilityDate(
    inventoryProperties.expectedPreOrderAvailabilityDate
  );
  model.atpQty = mapAtpQty(inventoryProperties.atpQty);
  model.preOrderedQty = mapPreOrderedQty(inventoryProperties.preOrderedQty);
  model.backOrderedQty = mapBackOrderedQty(inventoryProperties.backOrderedQty);
  model.lowStockThreshold = mapLowStockThreshold(inventoryProperties.lowStockThreshold);
  model.outOfStockThreshold = mapOutOfStockThreshold(inventoryProperties.outOfStockThreshold);

  return model;
}

/**
 * @param {boolean|undefined} available
 * @returns {boolean}
 */
function mapAvailable(available) {
  if (available) {
    return available;
  }

  return false;
}

/**
 * @param {boolean|undefined} lowStock
 * @returns {boolean}
 */
function mapLowStock(lowStock) {
  if (lowStock) {
    return lowStock;
  }

  return false;
}

/**
 * @param {string|undefined} binName
 * @returns {string}
 */
function mapBinName(binName) {
  if (binName) {
    return binName;
  }

  return '';
}

/**
 * @param {boolean|undefined} backOrdered
 * @returns {boolean}
 */
function mapBackOrdered(backOrdered) {
  if (backOrdered) {
    return backOrdered;
  }

  return false;
}

/**
 * @param {number|undefined} expectedBackOrderAvailabilityDate
 * @returns {number}
 */
function mapExpectedBackOrderAvailabilityDate(expectedBackOrderAvailabilityDate) {
  if (expectedBackOrderAvailabilityDate) {
    return expectedBackOrderAvailabilityDate;
  }

  return 0;
}

/**
 * @param {boolean|undefined} preOrdered
 * @returns {boolean}
 */
function mapPreOrdered(preOrdered) {
  if (preOrdered) {
    return preOrdered;
  }

  return false;
}

/**
 * @param {number|undefined} expectedPreOrderAvailabilityDate
 * @returns {number}
 */
function mapExpectedPreOrderAvailabilityDate(expectedPreOrderAvailabilityDate) {
  if (expectedPreOrderAvailabilityDate) {
    return expectedPreOrderAvailabilityDate;
  }

  return 0;
}

/**
 * @param {number|undefined} atpQty
 * @returns {number}
 */
function mapAtpQty(atpQty) {
  if (atpQty) {
    return atpQty;
  }

  return 0;
}

/**
 * @param {number|undefined} preOrderedQty
 * @returns {number}
 */
function mapPreOrderedQty(preOrderedQty) {
  if (preOrderedQty) {
    return preOrderedQty;
  }

  return 0;
}

/**
 * @param {number|undefined} backOrderedQty
 * @returns {number}
 */
function mapBackOrderedQty(backOrderedQty) {
  if (backOrderedQty) {
    return backOrderedQty;
  }

  return 0;
}

/**
 * @param {number|null|undefined} lowStockThreshold
 * @returns {number|null}
 */
function mapLowStockThreshold(lowStockThreshold) {
  if (lowStockThreshold) {
    return lowStockThreshold;
  }

  return null;
}

/**
 * @param {number|null|undefined} outOfStockThreshold
 * @returns {number|null}
 */
function mapOutOfStockThreshold(outOfStockThreshold) {
  if (outOfStockThreshold) {
    return outOfStockThreshold;
  }

  return null;
}

module.exports = mapInventoryProperties;
